// ─── Config équipes ───────────────────────────────────────────────
export const ESCALADE_TEAMS = [
  { type: 0, label: 'Paramétrage', desc: 'Config & réglages système', color: '#2A66C6', bg: '#EEEDFE', border: '#AFA9EC' },
  { type: 1, label: 'IT / Infrastructure', desc: 'Réseau, matériel & infra', color: '#3B6D11', bg: '#EAF3DE', border: '#C0DD97' },
  { type: 2, label: 'Développement', desc: 'Bugs logiciels & évolutions', color: '#185FA5', bg: '#E6F1FB', border: '#9EC8F0' },
];


export const getTeam = (type) => ESCALADE_TEAMS.find(t => t.type === type) ?? ESCALADE_TEAMS[0];

/**
 * Règle métier :
 *   type === 2 (Dev) → peut changer vers IT (type 1) uniquement
 *   type === 0 (Paramétrage) | type === 1 (IT) → pas de changement d'équipe
 */
export const canChangeTeam = (activeType) => activeType === 2;


/**
 * Équipes cibles autorisées selon l'équipe active
 *   Dev → peut aller vers IT seulement
 */
export const getAllowedTargetTeams = (activeType) => {
  if (activeType === 2) return ESCALADE_TEAMS.filter(t => t.type === 1);
  return [];
};


// ─── Formatage date ───────────────────────────────────────────────
export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const d = new Date(dateStr);
  return d.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
    + ' ' + d.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
};
